import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../GlobalContext";

export default function LogoutWatcher({ type }) {
  const { isUnauthorised, setAdmin } = useGlobalContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (isUnauthorised) {
      if (type === "admin") {
        sessionStorage.removeItem("admin");
        setAdmin(null);
        navigate("/login");
      }

      if (type === "volunteer") {
        sessionStorage.removeItem("volunteerData");
        sessionStorage.removeItem("volunteerToken");
        navigate("/volunteer/login");
      }
    }
  }, [isUnauthorised, type, navigate, setAdmin]);

  return null;
}
